import { housingAllowanceForm } from "modules/ebiForms/definitions/sharedHousing";
import { EEbiFormOffice, IEbiFormDefinition } from "modules/ebiForms/typings";

/**
 * B12. Wniosek o przyznanie dodatku mieszkaniowego (urząd gminy) — art. 7 ustawy z 21.06.2001 r. o dodatkach
 * mieszkaniowych (t.j. Dz.U. 2023 poz. 1335; „ustawa z 1994 r.” z listy postępowań to uchylona ustawa o najmie lokali).
 * Definicja wspólna z C8 (ta sama procedura w ośrodku pomocy społecznej / centrum świadczeń): housingAllowanceForm
 * w sharedHousing.ts — tam wzory (propozycja MRiT dla gmin i druk Poznania, pobrane 22.10.2026). Wzór wniosku i deklaracji
 * ustala rada gminy uchwałą (art. 7 ust. 1e) — przy wdrożeniu porównać z uchwałą danej gminy.
 */
const B12: IEbiFormDefinition = housingAllowanceForm({
  code: "B12",
  office: EEbiFormOffice.Municipality,
  organ: "Wójt / Burmistrz / Prezydent Miasta (decyzję może wydać upoważniony kierownik ośrodka pomocy społecznej — art. 7 ust. 1a)",
  description: "Dodatek mieszkaniowy na pokrycie wydatków na lokal — wniosek z deklaracją o dochodach gospodarstwa domowego.",
});

export default B12;
